module.exports = __webpack_public_path__ + "img/City4.png";